import { CropFree } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import PurchaseInfo from "./purchaseInfo";
import Logo from "../../../../../assets/images/Girlush Logo.png"
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const PurchaseReturn = () => {
  const classes = useStyle();
  const [data, setData] = useState([])
  const navigate = useNavigate()
  const [postData, setPostData] = useState({
    docdate: moment().format('YYYY/MM/DD'), 
    partycode: 0,
    amount: 0,
    subtotal_amount: "",
    gst_per: 0,
    gst_amt: 0,
    cess_per: 0,
    cess_amt: 0,
    roff:"",
    billno:"",
    company_id: 0,
    purchase_return_details:[]
  })

  return (
    <Grid  className={classes.root}>
      <Helmet><title>Purchase Return</title></Helmet>
      <Grid className={classes.titleInfo} sx={{paddingBlock:"25px"}}>
      <Grid className="flex justify-between items-center">
          <Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",}}/>
          <Typography  fontWeight={600} ml={1} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",fontSize:20}}>GIRLUSH</Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>Purchase Return</Typography>
      <Typography>Press F11 to Full Screen </Typography>
      {/* <CropFree/> */}
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,}}>
          <Grid className="border-b" sx={{height:'fit-content'}}><PurchaseInfo setData={setData} setPostData={setPostData} postData={postData} /></Grid>
          <Grid className="p-2 " sx={{flex:1, height:'100%',maxHeight:"80%" , overflow:"auto"}}><BillingTable data={data} setData={setData} setPostData={setPostData}/></Grid>
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo setData={setData} data={data} postData={postData} setPostData={setPostData}/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PurchaseReturn;
